module.exports = __webpack_public_path__ + "static/media/member-logo3.f037b1b9.jpg";